/**
 * ScholarSync — Checkout Cancel Page
 * File: frontend/src/CheckoutCancel.js
 * 
 * Shown when user cancels/backs out of Stripe Checkout.
 * Friendly messaging with option to try again.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CheckoutCancel() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '40px 20px'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        padding: '48px 40px',
        maxWidth: 480,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>👋</div>
        <h1 style={{ color: '#1a1a2e', marginBottom: 12 }}>No problem!</h1>
        <p style={{ color: '#555', fontSize: 16, lineHeight: 1.6, marginBottom: 32 }}>
          Your checkout was canceled and you haven't been charged. 
          Come back anytime when you're ready.
        </p>

        <button
          onClick={() => navigate('/checkout')}
          style={{
            background: '#4a6cf7',
            color: '#fff',
            border: 'none',
            padding: '14px 36px',
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer',
            width: '100%',
            marginBottom: 12
          }}
        >
          Try Again
        </button>

        <button
          onClick={() => navigate('/')}
          style={{
            background: 'transparent',
            color: '#666',
            border: 'none',
            padding: '12px',
            fontSize: 14,
            cursor: 'pointer'
          }}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
